import type { AppVueRouter } from '@modules/core/services/router/types';
import {
  AFFILIATE_TRACKERS_PERMISSIONS,
  AFFILIATE_TRACKERS_ROUTE_NAME,
} from '@modules/affiliate-trackers/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  AFFILIATE_TRACKERS_CONDITION_ROUTE_NAME,
} from './constants';

export class AffiliateProgramCommissionsEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(AFFILIATE_TRACKERS_ROUTE_NAME, {
      name: AFFILIATE_TRACKERS_CONDITION_ROUTE_NAME,
      path: 'condition/:id',
      permission: AFFILIATE_TRACKERS_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliateTrackersConditionPage/AffiliateTrackersConditionPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(): void {}
}
